module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": _vm.subNavTitle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [(this.capsule === 'draft-edit') ? _c('f7-list', {
    staticClass: "draftTitle"
  }, [_c('f7-list-item', [_c('f7-label', {
    staticClass: "paymentsRequestSubOption formLabel formLabelPayment"
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("Draft name")]), _vm._v(" "), _c('f7-input', {
    staticClass: "paymentsRequestSubOption",
    attrs: {
      "placeholder": "Draft name",
      "type": "text"
    },
    model: {
      value: (_vm.draftName),
      callback: function($$v) {
        _vm.draftName = $$v
      },
      expression: "draftName"
    }
  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('form-accordion', {
    attrs: {
      "title": _vm.$t('common.formsSubTitle.item_info', {
        itemname: _vm.$t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))
      })
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t(_vm.common.nme),
      "placeholderValue": _vm.$t('common.debtor_name')
    },
    model: {
      value: (_vm.debtorName),
      callback: function($$v) {
        _vm.debtorName = $$v
      },
      expression: "debtorName"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.idtfr'),
      "placeholderValue": _vm.$t('common.debtor_email')
    },
    model: {
      value: (_vm.debtorEmail),
      callback: function($$v) {
        _vm.debtorEmail = $$v
      },
      expression: "debtorEmail"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('bank_accounts.bank_account_singular'),
      "placeholderValue": _vm.$t('common.debtor_iban')
    },
    model: {
      value: (_vm.debtorBank),
      callback: function($$v) {
        _vm.debtorBank = $$v
      },
      expression: "debtorBank"
    }
  })], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('form-accordion', {
    attrs: {
      "title": "common.formsSubTitle.my_acc_info"
    }
  }, [_c('div', {
    staticClass: "form-group row showSmallScreenOnly"
  }, [_c('label', {
    staticClass: "col-sm-8 col-form-label labelAccordionForm",
    class: {
      redFont: _vm.creditorColor
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")]), _vm._v("\n                    My Account\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "button button-round button-inner-color",
    on: {
      "click": function($event) {
        return _vm.accountPicker($event)
      }
    }
  }, [_vm._v("\n                      Select\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row showSmallScreenOnly"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditorBankName),
      expression: "creditorBankName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "account-input",
      "type": "text",
      "placeholder": "Choose account",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.creditorBankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.creditorBankName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("\n                      " + _vm._s(_vm.$t('bank_accounts.bank_account_singular_small')) + "\n                      "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("* ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.creditorBank),
      expression: "creditorBank"
    }],
    staticClass: "form-control showLargeScreenOnly",
    attrs: {
      "id": "sel2",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.creditorBank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('creation_forms.slct_an_acc')))]), _vm._v(" "), _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('option', {
      key: bankAccount.id,
      domProps: {
        "value": bankAccount.iban
      }
    }, [_vm._v("\n                        " + _vm._s(bankAccount.name) + " (" + _vm._s(_vm.$engine.bankAccounts.getCurrency(bankAccount.zoneCode)) + ")\n                      ")])
  })], 2)])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('form-accordion', {
    attrs: {
      "hasDatePicker": "",
      "title": "MODULAR LOAN DETAILS"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.rsn'),
      "placeholderValue": _vm.$t('common.rsn')
    },
    model: {
      value: (_vm.remittanceInformation),
      callback: function($$v) {
        _vm.remittanceInformation = $$v
      },
      expression: "remittanceInformation"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.amnt'),
      "placeholderValue": _vm.$t('common.amnt'),
      "inputType": "number"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.date_label'),
      "placeholderValue": _vm.$t('common.slct_date'),
      "inputType": "date"
    },
    model: {
      value: (_vm.depositExecutionDate),
      callback: function($$v) {
        _vm.depositExecutionDate = $$v
      },
      expression: "depositExecutionDate"
    }
  }), _vm._v(" "), _c('form-write-group-label-input', {
    attrs: {
      "isMandatory": true,
      "idLabel": _vm.$t('common.deposit_amnt_label'),
      "placeholderValue": _vm.$t('common.deposit_amnt_label'),
      "inputType": "number"
    },
    model: {
      value: (_vm.deposit),
      callback: function($$v) {
        _vm.deposit = $$v
      },
      expression: "deposit"
    }
  })], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('form-accordion', {
    attrs: {
      "open": "",
      "title": _vm.$t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton buttonAccordionForm longword-word",
    staticStyle: {
      "margin-bottom": "1rem"
    },
    on: {
      "click": function($event) {
        return _vm.openImportAttachmentInvoice()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.import_item', {
    itemname: this.$i18n.t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))
  })) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachmentNameLabel),
      expression: "attachmentNameLabel"
    }],
    staticClass: "form-control inputAccordionForm",
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "application-file-input"
    },
    domProps: {
      "value": (_vm.attachmentNameLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachmentNameLabel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hiddenElementAllSize",
    attrs: {
      "type": "text",
      "id": "recommendation-list-input"
    }
  })])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: " form-group row",
    class: _vm.colorBottomButton
  }, [(_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [(_vm.hasAttachment) ? _c('f7-button', {
    staticClass: "button-round button-inner-color buttonAccordionForm attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v("View Attachment")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [(_vm.hasAttachment) ? _c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v("Download Attachment")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [((typeof _vm.attachmentName) !== 'undefined' && _vm.attachmentName !== '') ? _c('f7-button', {
    staticClass: "button-round button-inner-color attachmentButton",
    on: {
      "click": function($event) {
        return _vm.clearAttachement()
      }
    }
  }, [_vm._v("Clear")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (false && _vm.hasAttachment) ? _c('div', {
    staticClass: "row"
  }, [(_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color buttonAccordionForm attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v("View Attachment")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isSmartphone) ? _c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [_c('f7-button', {
    staticClass: "button-round button-inner-color buttonAccordionForm attachmentButton",
    on: {
      "click": function($event) {
        return _vm.view(_vm.attachmentId)
      }
    }
  }, [_vm._v("Download Attachment")])], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (_vm.rulesEnabled) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.rulesEnabled) ? _c('ul', [_c('form-accordion', {
    attrs: {
      "title": _vm.$t('regles_metier.titles.rules')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    on: {
      "change": function($event) {
        return _vm.getAllInstallmentRules()
      }
    },
    model: {
      value: (_vm.hasRegles),
      callback: function($$v) {
        _vm.hasRegles = $$v
      },
      expression: "hasRegles"
    }
  }, [_vm._v("\n                        Add installment rules\n                      ")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.negotiationAllowed),
      callback: function($$v) {
        _vm.negotiationAllowed = $$v
      },
      expression: "negotiationAllowed"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('regles_metier.allow_edit_installments_rules')) + "\n                      ")])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasRegles),
      expression: "hasRegles"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('regles_metier.select_installment_template')))]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    on: {
      "change": function($event) {
        return _vm.setInstallmentRules($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": 0
    }
  }, [_vm._v(_vm._s(_vm.$t('regles_metier.none_installment_template')))]), _vm._v(" "), _vm._l((_vm.allRules), function(rule) {
    return _c('option', {
      key: rule.idReglesMetier,
      domProps: {
        "value": rule.idReglesMetier
      }
    }, [_vm._v(_vm._s(((rule.nom) + " – [installments: " + (rule.nbEcheances.min) + " - " + (rule.nbEcheances.max) + "]")))])
  })], 2)])])], 1), _vm._v(" "), (_vm.hasRegles) ? _c('regles-form', {
    attrs: {
      "hideInfo": true,
      "hideInterests": true,
      "value": _vm.reglesMetier
    },
    on: {
      "input": function($event) {
        _vm.reglesMetier = $event
      },
      "echeance-changed": function($event) {
        return _vm.echeanceChanged($event)
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.rulesEnabled && _vm.reglesMetier.idReglesMetier && _vm.hasRegles) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.rulesEnabled && _vm.reglesMetier.idReglesMetier && _vm.hasRegles) ? _c('ul', [_c('form-accordion', {
    attrs: {
      "title": _vm.$t('regles_metier.titles.rules_details')
    }
  }, [(_vm.reglesMetier.idReglesMetier && _vm.hasRegles) ? _c('regles-details', {
    attrs: {
      "reglesMetier": _vm.reglesMetier
    }
  }) : _c('p', [_vm._v(_vm._s(_vm.$t('regles_metier.details.no_rules')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('form-accordion', {
    attrs: {
      "hasDatePicker": "",
      "title": _vm.$t('regles_metier.titles.installments')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.reglesMetier.nbEcheances.min > _vm.reglesMetier.nbEcheances.max
    },
    model: {
      value: (_vm.hasInstallments),
      callback: function($$v) {
        _vm.hasInstallments = $$v
      },
      expression: "hasInstallments"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('regles_metier.add_installments')) + "\n                      ")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.modificationInstallmentsAllowed),
      callback: function($$v) {
        _vm.modificationInstallmentsAllowed = $$v
      },
      expression: "modificationInstallmentsAllowed"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('regles_metier.edit_installments')) + "\n                      ")])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.hasInstallments) ? _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('regles_metier.select_nb_installments')))]), _vm._v(" "), (_vm.hasRegles && _vm.reglesMetier.idReglesMetier) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payNumber),
      expression: "payNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.hasInstallments
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.payNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$R.range(parseInt(_vm.reglesMetier.nbEcheances.min), parseInt(_vm.reglesMetier.nbEcheances.max) + 1)), function(nb) {
    return _c('option', {
      domProps: {
        "value": nb
      }
    }, [_vm._v("\n                                " + _vm._s(nb) + "\n                        ")])
  }), 0) : _c('b-form-input', {
    attrs: {
      "disabled": !_vm.hasInstallments,
      "type": "number",
      "min": "1",
      "max": "24"
    },
    model: {
      value: (_vm.payNumber),
      callback: function($$v) {
        _vm.payNumber = $$v
      },
      expression: "payNumber"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.hasInstallments) ? _c('echeancier', {
    attrs: {
      "numPay": _vm.payNumber,
      "min": _vm.borneInf,
      "amount": _vm.amount,
      "ccy": _vm.ccy,
      "deposit": _vm.deposit
    },
    model: {
      value: (_vm.multPmts),
      callback: function($$v) {
        _vm.multPmts = $$v
      },
      expression: "multPmts"
    }
  }) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 offset-md-4"
  }, [(_vm.clearance === '1' | _vm.clearance === '2') ? _c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.sendDirectDebit
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paper-plane"
  }), _vm._v("\n            Send Request\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "showLargeScreenOnly"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../../assets/static/images/icons/inbox_out.png")
    }
  }), _vm._v("\n                  New Modular Loan Request\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly"
  }, [_c('h6', {
    staticClass: "content-block labelAccordionForm creationFormTitle"
  }, [_c('img', {
    staticClass: "formIcon",
    attrs: {
      "src": require("../../../assets/static/images/icons/inbox_out.png")
    }
  }), _vm._v("\n                  New Modular Loan Request\n                ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74d73ec8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74d73ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/DDCreateTemplate.vue
// module id = 1694
// module chunks = 2